import PropTypes from "prop-types";
import React from "react";

const InternalMenu = ({ url }) => {
  // check window location and set state based on url
  const isAuthenticated = document.cookie.indexOf("authenticated=true") >= 0;
  console.log("Auth", isAuthenticated);

  return (
    <>
      <div className="w-full text-white bg-secondary">
        <div className="container">
          <div className="flex justify-end">
            {isAuthenticated ? (
              <a
                href="/logout"
                className="px-4 py-2 mx-auto mr-1 text-white no-underline"
              >
                Logout
              </a>
            ) : (
              <a
                href={url}
                className="px-4 py-2 mx-auto mr-1 text-white no-underline"
              >
                Admin
              </a>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

InternalMenu.propTypes = {
  title: PropTypes.string,
};

export default InternalMenu;
